import {BrowserModule} from '@angular/platform-browser';
import {NgModule, Renderer2, RendererFactory2} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {Routes, RouterModule} from '@angular/router';
import 'hammerjs';
import 'ngx-dropdown';
import {HammerGestureConfig, HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {NavigationComponent} from './shared/navigation/navigation.component';
import {ServerMessageComponent} from './shared/server-message/server-message.component';
import {SelectModule} from 'ng-select';
import {LotteriesNavigationComponent} from './shared/navigation/lotteries-navigation/lotteries-navigation/lotteries-navigation.component';
import {CounterComponent} from './shared/navigation/lotteries-navigation/lotteries-navigation/counter/counter.component';
import {MessageContainerComponent} from './shared/message-container/message-container.component';
import {HomeComponent} from './home/home.component';
import {PagerService} from './_services/index';
import {HttpClientModule, HttpClient} from '@angular/common/http';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {DerpPipe} from './derp.pipe';
import {BalanceDecimalPipe} from './balance-decimal.pipe';
import {SyndicateComponent} from './shared/syndicate/syndicate.component';
import {RegisterUserComponent} from './register-user/register-user.component';
import {HowItWorksComponent} from './shared/how-it-works/how-it-works.component';
import {LittleAboutUsComponent} from './shared/little-about-us/little-about-us.component';
import {TotalWinsComponent} from './shared/total-wins/total-wins.component';
import {HttpLoaderFactory, SharedModule} from './shared.module';
import {PrivacyComponent} from './help/privacy/privacy.component';
import {JinniErrorModalComponent} from './jinni-error-modal/jinni-error-modal.component';
import {DeviceDetectorModule} from 'ngx-device-detector';
import {ConfigModule} from '@ngx-config/core';
import {environment} from '../environments/environment';
import {NgxTrimModule} from 'ngx-trim';
import {ScratchHomeComponent} from './scratch/scratch-home/scratch-home.component';
import {GetDeviceService} from './_services/get-device.service';
import {ParamsService} from './_services/params.service';
import {CartService} from './_services/cart.service';
import {TimeService} from './_services/time.service';
import {LanguageService} from './_services/language.service';
import {UserService} from './_services/user.service';
import {FreshRegistrationComponent} from './fresh-registration/fresh-registration.component';
import {JinniTooltipComponent} from './jinni-tooltip/jinni-tooltip.component';
import {LoginComponent} from './login/login.component';
import {BowserModule, BowserService} from 'ngx-bowser';
import {NgxMaskModule} from 'ngx-mask';
import {ClickOutsideModule} from 'ng4-click-outside';
import {CurrencyPipe, registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {TooltipDialogComponent} from './tooltip-dialog/tooltip-dialog.component';
import { FreeSpinButtonComponent } from './shared/navigation/free-spin-button/free-spin-button.component';
registerLocaleData(localeDe);
import localeAt from '@angular/common/locales/de-AT';

registerLocaleData(localeAt);
import localeCa from '@angular/common/locales/en-CA';

registerLocaleData(localeCa);
import localeCaOrig from '@angular/common/locales/ca';

registerLocaleData(localeCaOrig);
import localeIe from '@angular/common/locales/en-IE';

registerLocaleData(localeIe);
import localeNg from '@angular/common/locales/en-NG';

registerLocaleData(localeNg);
import localeNz from '@angular/common/locales/en-NZ';
import {RegisterSuccessComponent} from './shared/register-success/register-success.component';
import {JackpotPipe} from './jackpot.pipe';
import {ReplaceEuroPipe} from './replace-euro.pipe';
import {ReplacePipe} from './replace.pipe';
import {PaystackComponent} from './paystack/paystack.component';

registerLocaleData(localeNz);
import {DatePipe} from '@angular/common';

const routes: Routes = [
    {path: '', component: HomeComponent, data: {breadcrumb: 'Troll Tech Lotto',},},
    {path: 'not-allowed', component: HomeComponent, data: {breadcrumb: 'Troll Tech Lotto',},},
    {path: ':lang/successful-registration', component: RegisterSuccessComponent, data: {breadcrumb: 'Troll Tech Lotto',}},
    {
        path: ':lang/maintenance-break',
        loadChildren: './shared/page-maintenance-break/page-maintenance-break.module#PageMaintenanceBreakModule'
    },
    {path: '404', loadChildren: './shared/page404/page404.module#Page404Module'},
    {path: ':lang/contact-us', loadChildren: './shared/contact-us/contact-us.module#ContactUsModule'},
    {path: ':lang/about-us', loadChildren: './shared/about-us/about-us.module#AboutUsModule'},
    {path: ':lang/terms-conditions', loadChildren: './help/terms/terms.module#TermsModule'},
    {path: ':lang/safety-security', loadChildren: './help/safety/safety.module#SafetyModule'},
    {path: ':lang/privacy-policy', loadChildren: './help/privacy-notice/privacy-notice.module#PrivacyNoticeModule'},
    {path: ':lang/cookie-policy', loadChildren: './help/cookie-policy/cookie-policy.module#CookiePolicyModule'},
    {path: ':lang/bonus-terms', loadChildren: './help/bonus/bonus.module#BonusModule'},
    {path: ':lang/scratchcards', loadChildren: './scratch/scratch.module#ScratchModule'},
    {path: ':lang/games', loadChildren: './insta-games/insta-games.module#InstaGamesModule'},
    {path: ':lang/game-rules', loadChildren: './help/gamerules/gamerules.module#GamerulesModule'},
    {path: ':lang/responsible-gaming-policy', loadChildren: './help/rgp/rgp.module#RgpModule'},
    {path: ':lang/faq', loadChildren: './shared/faq/faq.module#FaqModule'},
    {path: ':lang/dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule'},
    {path: ':lang/lotteries-results', loadChildren: './lotteries/lotteries.module#LotteriesModule'},
    {path: ':lang/cart', loadChildren: './shared/cart/cart.module#CartModule'},
    {path: ':lang/casino', loadChildren: './casino/casino.module#CasinoModule'},
    {path: ':lang/lotteries', loadChildren: './lottery/lottery.module#LotteryModule'},
    {path: ':lang/unsubscribe', loadChildren: './shared/unsubscribe/unsubscribe.module#UnsubscribeModule'},
    {path: ':lang/firstTicketFree', loadChildren: './help/first-ticket-free/first-ticket-free.module#FirstTicketFreeModule'},
    {path: ':lang/twoTicketsFree', loadChildren: './help/two-tickets-free/two-tickets-free.module#TwoTicketsFreeModule'},
    {path: ':lang/five-tickets-free', loadChildren: './help/five-tickets-free/five-tickets-free.module#FiveTicketsFreeModule'},
    {path: ':lang/two-for-one', loadChildren: './help/two-for-one/two-for-one.module#TwoForOneModule'},
    {path: ':lang/15k-tournament', loadChildren: './help/wild-chase-tour/wild-chase-tour.module#WildChaseTourModule'},
    {path: ':lang/five-for-one', loadChildren: './help/five-for-one/five-for-one.module#FiveForOneModule'},
    {path: ':lang/four-for-one', loadChildren: './help/four-for-one/four-for-one.module#FourForOneModule'},
    {path: ':lang/four-for-two', loadChildren: './help/four-for-two/four-for-two.module#FourForTwoModule'},
    {path: ':lang/five-for-two', loadChildren: './help/five-for-two/five-for-two.module#FiveForTwoModule'},
    {path: ':lang/syndicate-100-100', loadChildren: './shared/teamplay100/teamplay100.module#Teamplay100Module'},
    {path: ':lang/syndicate-200-100', loadChildren: './shared/teamplay200/teamplay200.module#Teamplay200Module'},
    {path: ':lang/20-discount', loadChildren: './help/twenty-discount/twenty-discount.module#TwentyDiscountModule'},
    {path: ':lang/10-discount', loadChildren: './help/ten-discount/ten-discount.module#TenDiscountModule'},
    {path: ':lang/50-refund', loadChildren: './help/fifty-refund/fifty-refund.module#FiftyRefundModule'},
    {path: ':lang/three-for-one', loadChildren: './help/three-for-one/three-for-one.module#ThreeForOneModule'},
    {path: ':lang/ten-for-five', loadChildren: './help/ten-for-five/ten-for-five.module#TenForFiveModule'},
    {path: ':lang/six-for-three', loadChildren: './help/six-for-three/six-for-three.module#SixForThreeModule'},
    {path: ':lang/15-discount', loadChildren: './help/fifteen-discount/fifteen-discount.module#FifteenDiscountModule'},
    {path: ':lang/1-ticket-free', loadChildren: './help/one-ticket-free/one-ticket-free.module#OneTicketFreeModule'},
    {path: ':lang/bonus-policy', loadChildren: './shared/bonus-policy/bonus-policy.module#BonusPolicyModule'},
    {path: ':lang/wagering-table', loadChildren: './shared/wagering-table/wagering-table.module#WageringTableModule'},
    {path: ':lang/packages', loadChildren: './bundles/bundles.module#BundlesModule'},
    {path: ':lang/winner', loadChildren: './winaija/local-draw/local-draw.module#LocalDrawModule'},
    {
        path: ':lang/exclusive-offer-terms',
        loadChildren: './help/exclusive-offer-terms/exclusive-offer-terms.module#ExclusiveOfferTermsModule'
    },
    {
        path: ':lang/exclusive-offer-terms2',
        loadChildren: './help/exclusive-offer-terms2/exclusive-offer-terms2.module#ExclusiveOfferTerms2Module'
    },
    {path: ':lang/home', redirectTo: ''},
    {path: '**', redirectTo: '404'}


];

export class MyHammerConfig extends HammerGestureConfig {
    overrides = <any>{
        'pan': {threshold: 5, direction: 6},
        'swipe': {
            velocity: 0.4,
            threshold: 20,
            direction: 6,
            touchAction: 'auto'
        }
    };
}

@NgModule({
    declarations: [
        AppComponent,
        TotalWinsComponent,
        NavigationComponent,
        ServerMessageComponent,
        LotteriesNavigationComponent,
        CounterComponent,
        MessageContainerComponent,
        HomeComponent,
        PrivacyComponent,
        DerpPipe,
        BalanceDecimalPipe,
        SyndicateComponent,
        RegisterUserComponent,
        HowItWorksComponent,
        LittleAboutUsComponent,
        ScratchHomeComponent,
        FreshRegistrationComponent,
        JinniTooltipComponent,
        LoginComponent,
        RegisterSuccessComponent,
        ReplacePipe,
        PaystackComponent,
        JinniErrorModalComponent,
        FreeSpinButtonComponent
    ],
    imports: [
        NgxTrimModule,
        BowserModule,
        SharedModule.forRoot(),
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        SelectModule,
        RouterModule.forRoot(routes, {useHash: false}),
        NgxMaskModule.forRoot(),
        DeviceDetectorModule.forRoot(),
        ConfigModule,
        ClickOutsideModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports: [RouterModule, NgxTrimModule, ReplacePipe],
    providers: [
        PagerService,
        BowserService,
        DatePipe,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig
        },
        GetDeviceService,
        ParamsService,
        CartService,
        TimeService,
        LanguageService,
        UserService,
        JackpotPipe,
        CurrencyPipe,
        ReplaceEuroPipe
    ],
    bootstrap: [AppComponent]
})

export class AppModule {

}


